(() => {
  const dialog = document.getElementById('review-reader');
  if (!dialog) return;
  const body = dialog.querySelector('.review-reader-body');
  document.querySelectorAll('.review-open').forEach(button => {
    button.addEventListener('click', () => {
      const template = button.closest('article, figure').querySelector('.review-template');
      body.replaceChildren(template.content.cloneNode(true));
      dialog.showModal();
      dialog.scrollTop = 0;
    });
  });
  dialog.querySelector('.review-reader-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
})();
